export const filterConditionLteIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M15.571 11.954l-9.669-4.24 9.669-4.24L14.086 2 3 7.714l11.086 5.714zm0 4.572L4.143 11.143 3 12.286 14.086 18z"/></svg>`,
  name: 'filter-condition-lte',
};
